import React from "react"
import KosmoButton from "@/UI/Buttons/KosmoButton"
import { useTranslation } from "react-i18next"
import SettingSection from "../../shared/SettingSection"
import SettingContentWrapper from "../../shared/SettingContentWrapper"
import UserDetails from "./components/UserDetails"

interface IGeneralSettingsProps {}

const GeneralSettings: React.FC<IGeneralSettingsProps> = () => {
  const { t } = useTranslation()

  return (
    <>
      <UserDetails />
      <SettingSection title={t("profile.GeneralSettings.advancedSettings")}>
        <SettingContentWrapper>
          <p className="m-0 font-semibold">{t("profile.GeneralSettings.deleteAccount")}</p>
          <p className="m-0 text-gray-400">{t("profile.GeneralSettings.deleteAccountDesc")}</p>
          <div className="mt-2">
            <KosmoButton isDisabled={true}>
              {t("profile.GeneralSettings.deleteAccount")}
            </KosmoButton>
          </div>
        </SettingContentWrapper>
      </SettingSection>
    </>
  )
}

export default GeneralSettings
